import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import Pricing from './components/Pricing';
import SEO from './components/SEO';
import { SuperHitProvider } from './contexts/SuperHitContext';
import SuperHitPopup from './components/SuperHitPopup';
import CursorEffect from './components/CursorEffect';
import SoundToggle from './components/SoundToggle';
import { soundSystem } from './utils/soundSystem';

function App() {
  useEffect(() => {
    soundSystem.init();

    const handleClick = (e: MouseEvent) => {
      const target = e.target as Element;
      if (target?.closest?.('button, a, [role="button"]')) {
        soundSystem.playClick();
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);

  return (
    <HelmetProvider>
      <SuperHitProvider>
        <Router>
          <div className="min-h-screen bg-neutral-950 text-white">
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/pricing" element={<Pricing />} />
            </Routes>
            <SuperHitPopup />
            <SoundToggle />
            <CursorEffect />
          </div>
        </Router>
      </SuperHitProvider>
    </HelmetProvider>
  );
}

export default App;
